<aside class="brand_panel" [class.with_visual]="variant === 'signup'">
	<a class="brand_logo" href="https://supersee.io/" target="_blank" rel="noopener noreferrer">
		<img src="assets/images/SuperSee_horizontal_white_text_transparent_bg.webp" alt="SuperSee">
	</a>

	<!-- Login: returning admins get a short reminder of what the product is for -->
	<div class="brand_body" *ngIf="variant === 'login'">
		<h1 class="brand_headline">Know where team hours go. <span>See where to step in.</span></h1>
		<p class="brand_sub">A clear view of your team's workday, with context instead of guesswork.</p>
		<ul class="brand_points">
			<li>Screenshots, Work Replay and app usage in one place</li>
			<li>A daily team summary on WhatsApp and email</li>
			<li>See what needs attention without chasing updates</li>
		</ul>
	</div>

	<!-- Signup: speak to the buyer who clicked through, then show the first week -->
	<div class="brand_body" *ngIf="variant === 'signup'">
		<p class="brand_eyebrow" *ngIf="copy.eyebrow">{{ copy.eyebrow }}</p>
		<h1 class="brand_headline">{{ copy.lead }} <span>{{ copy.accent }}</span></h1>
		<p class="brand_sub">{{ copy.sub }}</p>

		<p class="brand_kicker">Your first week</p>
		<ol class="brand_steps">
			<li><span>Install on your own computer <small>Windows, Mac or Linux · under 10 MB</small></span></li>
			<li><span>Add one person, up to five</span></li>
			<li><span>Review one busy week</span></li>
		</ol>

		<!-- Real Capterra review (Aug 2026), quoted in full from the reviewer's "What they liked" -->
		<figure class="brand_quote">
			<blockquote>
				"The most helpful feature is the ability to monitor all systems in one place. It gives us better
				visibility, makes it easier to track everything, and helps ensure nothing is missed."
			</blockquote>
			<figcaption>Anbazhagaan A., CEO, Design company (11–50 employees) · Capterra review</figcaption>
		</figure>
	</div>

	<div class="brand_visual" *ngIf="variant === 'signup'">
		<img [src]="visualSrc" [alt]="visualAlt" loading="lazy">
	</div>
</aside>
